export const EMPLOYEE_CV_MD = `# Persönliche Informationen

**Name:** Daniel Weber
**Geburtsjahr:** 1996 (28 Jahre)
**Position:** Account Manager – Digital Solutions
**Abteilung:** B2B Sales & Digital Partnerships
**Standort:** Düsseldorf (Metro Campus)
**Bei Metro seit:** Juli 2022 (2 Jahre 8 Monate)

---

# Aktuelle Rolle

Daniel betreut eigenständig ein Portfolio von 18 mittelgroßen bis großen B2B-Kunden im Bereich Digital Solutions – darunter Marketplace-Integrationen, Data & Analytics Add-ons sowie digitale Einkaufsplattformen.

**Kernaufgaben:**
- Eigenverantwortliche Führung des gesamten Sales Cycles für Mid-Market-Accounts (ARR €50k–€300k)
- Cross- und Upsell an Bestandskunden (Schwerpunkt: Data Solutions, Analytics Dashboards)
- Unterstützung des Senior Account Manager-Teams bei strategischen Enterprise-Deals (ARR >€500k)
- Angebotserstellung und Business-Case-Entwicklung für komplexe Digitalprojekte
- Regelmäßige Quarterly Business Reviews (QBRs) mit Einkaufs- und IT-Entscheidern

**Direkte Führungskraft:** Sarah Köhler, Head of Digital Sales DACH

---

# Projekte bei Metro (Auswahl)

## Projekt 1 – Metro ASSIST Rollout (2022–2023)
**Rolle:** Junior-Projektmitglied im Sales-Team
**Kontext:** Einführung des Metro ASSIST Marketplace-Integrationsprodukts bei 40+ Pilotpartnern in Deutschland.
**Beitrag:**
- Erstellung von Value-Proposition-Slides und ROI-Kalkulatoren für das Partner-Onboarding
- Koordination zwischen Sales, Product und Customer Success
- Mitarbeit an der Pilotauswertung: Analyse von Aktivierungsraten und Conversion-Metriken
**Ergebnis:** 87 % der Pilotpartner verlängerten innerhalb der ersten 6 Monate
**Learning:** Erstmals eigenständige Business-Case-Berechnungen durchgeführt; Unsicherheit bei komplexen ROI-Szenarien erkannt

## Projekt 2 – Data Analytics Upsell Campaign „DataDrive 2023" (2023)
**Rolle:** Eigenverantwortlicher Account Manager
**Kontext:** Kampagne zur Einführung des Metro Data Analytics Dashboard Add-ons für bestehende Mid-Market-Kunden.
**Beitrag:**
- Pitching und eigenständige Verhandlungsführung mit 12 Bestandskunden
- Entwicklung kundenindividueller Demo-Szenarien auf Basis deren Einkaufsdaten
- Abschluss von 7 Upgrades (+€320k ARR), davon 4 ohne Beteiligung des Senior Teams
**Ergebnis:** Zielerreichung 140 % des persönlichen Jahrestargets
**Learning:** Verhandlungen auf Einkaufsleiter-Level blieben herausfordernd; Preisdiskussionen wurden oft an den Senior AM übergeben

## Projekt 3 – Enterprise Deal Support: Kaufland Digital (2024)
**Rolle:** Unterstützender Account Manager
**Kontext:** Strategischer Enterprise-Deal mit Kaufland für eine vollintegrierte digitale Einkaufsplattform (ARR €1,2M).
**Beitrag:**
- Erstellung von Executive Pitch Deck und Wettbewerbsanalyse
- Koordination von 6 Stakeholder-Meetings (IT, Einkauf, C-Level) gemeinsam mit Senior AM
- Mitentwicklung des kommerziellen Modells (Preis-Tier-Struktur) unter Anleitung
**Ergebnis:** Deal erfolgreich abgeschlossen (Q2 2024); Daniel als Co-Signatory benannt
**Learning:** Erste Begegnung mit Enterprise Deal Cycles und komplexer Stakeholder-Dynamik; Executive Presence und C-Level-Kommunikation noch ausbaufähig

---

# Frühere Erfahrungen

## Sales Development Representative – Contentserv GmbH, München (2021–2022)
**Bereich:** SaaS-Vertrieb (Product Information Management Software)
- Outbound Prospecting und Qualifizierung von Inbound-Leads (B2B, DACH-Region)
- Koordination von Discovery Calls zwischen Interessenten und Account Executives
- Aufbau und Pflege der CRM-Pipeline in Salesforce
- Konstant 110–120 % der monatlichen SQL-Quota erreicht

## Werkstudent Vertrieb & Business Development – Siemens AG, München (2019–2021)
**Bereich:** Smart Infrastructure (Building Technologies)
- Unterstützung bei der Erstellung von Angeboten für öffentliche Ausschreibungen
- Datenpflege und Reporterstellung in SAP und Excel
- Mitarbeit an einer Marktanalyse zur Expansion in den osteuropäischen Markt

---

# Ausbildung

**Bachelor of Science – Betriebswirtschaftslehre (BWL)**
Ludwig-Maximilians-Universität München (LMU), 2017–2021
Schwerpunkt: Marketing & Sales, Digital Business
Abschlussnote: 2,1
Bachelorarbeit: „Value-Based Pricing im B2B-SaaS-Umfeld: Methoden und Praxisbeispiele"

---

# Absolvierte Weiterbildungen bei Metro (E-Learning)

| Kurs | Abgeschlossen | Selbsteinschätzung |
|---|---|---|
| Strategic B2B Selling in Platform Businesses | Q1 2023 | 3/5 |
| Understanding the B2B Buyer Journey | Q1 2023 | 4/5 |
| Digital Communication in B2B Sales | Q2 2023 | 4/5 |
| Handling Objections Professionally | Q2 2023 | 3/5 |
| Prospecting & Lead Generation | Q3 2023 | 4/5 |
| Cross- & Upselling in Digital Services | Q4 2023 | 3/5 |

---

# Entwicklungsziele (nächste 12 Monate)

1. Eigenständige Führung von mindestens einem Enterprise-Deal (ARR >€500k)
2. Sichere und selbständige Verhandlung auf Einkaufsleiter- und C-Level
3. Strategische Account-Planung für die Top-5-Bestandskunden
4. Executive Pitches eigenständig konzipieren und durchführen
5. Datenbasierte Argumentation systematisch in Pitches integrieren

---

# Identifizierte Skill-Gaps

- Value-Based Selling (Fortgeschrittenenstufe): Argumente auf Geschäftsnutzen statt Features aufbauen
- Verhandlung auf Einkaufsleiter- und C-Level-Ebene
- Enterprise Account Planung und strategische Account-Strategie
- Commercial Modelling und Pricing-Verhandlung
- Executive Presence und Storytelling für C-Level-Meetings

`;



export const COMPLETED_COURSES = [
  'Strategic B2B Selling in Platform Businesses',
  'Understanding the B2B Buyer Journey',
  'Digital Communication in B2B Sales',
  'Handling Objections Professionally',
  'Prospecting & Lead Generation',
  'Cross- & Upselling in Digital Services'
];

export const DEVELOPMENT_GOALS = [
  'Eigenständige Führung von mindestens einem Enterprise-Deal (ARR >€500k)',
  'Sichere und selbständige Verhandlung auf Einkaufsleiter- und C-Level',
  'Strategische Account-Planung für die Top-5-Bestandskunden',
  'Executive Pitches eigenständig konzipieren und durchführen',
  'Datenbasierte Argumentation systematisch in Pitches integrieren'
];

export const SKILL_GAPS = [
  'Value-Based Selling (fortgeschritten)',
  'Verhandlung auf Einkaufsleiter- und C-Level',
  'Enterprise Account Planung',
  'Commercial Modelling und Pricing-Verhandlung',
  'Executive Presence und Storytelling'
];

export function getEmployeeCV() {
  return EMPLOYEE_CV_MD;
}

export function getCompletedCourses() {
  return [...COMPLETED_COURSES];
}

export function getDevelopmentGoals() {
  return [...DEVELOPMENT_GOALS];
}

export function getSkillGaps() {
  return [...SKILL_GAPS];
}
